import { Stack } from '@src/components';
import { DateField } from '@src/corelib/forms/generic';
import type { ComponentPropsWithoutRef } from 'react';

type DateFieldProps = ComponentPropsWithoutRef<typeof DateField>;

function FromField(props: DateFieldProps) {
  return <DateField fullWidth label="From" name="dateFrom" {...props} />;
}
function ToField(props: DateFieldProps) {
  return <DateField fullWidth label="To" name="dateTo" {...props} />;
}

export type DatesChangedPayload = {
  dateFrom?: Date | null;
  dateTo?: Date | null;
};

type DatesRangeFieldProps = {
  hoursView: boolean;
  onDatesChanged: (dates: DatesChangedPayload) => void;
};

export function DatesRangeField({
  hoursView,
  onDatesChanged,
}: DatesRangeFieldProps) {
  const onDateFromChanged = (dateFrom: Date) => onDatesChanged({ dateFrom });
  const onDateToChanged = (dateTo: Date) => onDatesChanged({ dateTo });
  return (
    <Stack spacing={2} direction="row">
      <FromField
        label={hoursView ? 'Date' : 'From'}
        onDateChanged={onDateFromChanged}
      />
      {!hoursView && <ToField onDateChanged={onDateToChanged} />}
    </Stack>
  );
}
